/* eslint @typescript-eslint/no-explicit-any:0 -- payload could have any types */
/* eslint @typescript-eslint/no-unsafe-assignment:0 -- payload could have any types */

import ActionTypes, { type Actions } from './actions.types';

import type { BPID } from '@energy-retailer/schema';

export type ActionProps = {
  type: ActionTypes;
  payload?: any;
};

export const setItems = (payload: BPID[]): Actions => ({
  type: ActionTypes.SetItems,
  payload,
});

export const setOptions = (payload: any): Actions => ({
  type: ActionTypes.SetOptions,
  payload,
});

export const setFilters = (payload: any): Actions => ({
  type: ActionTypes.SetFilters,
  payload,
});

export const resetFilters = () => ({
  type: ActionTypes.ResetFilters,
});
